import React from 'react';
import PropTypes from 'prop-types';
var MenuDivider = function MenuDivider() {
  return /*#__PURE__*/React.createElement("li", {
    className: "list border-bottom marginbottom-md margintop-md",
    role: "separator"
  });
};
MenuDivider.propTypes = {
  className: PropTypes.string
  // fullwidth
};
MenuDivider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MenuDivider",
  "props": {
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default MenuDivider;